module.exports = new __parcel__URL__("socrates.fb416e7c.png").toString();